



















































































































































































































import * as memberAPI from '@adobe/edex/frontend/api/member';
import Loader from '@adobe/edex/frontend/components/common/loader.vue';
import ConfirmModal from '@adobe/edex/frontend/components/common/confirm-modal.vue';
import OtpConfirmModal from '@adobe/edex/frontend/components/common/otpconfirm-modal.vue';
import '@adobe/edex/ui/shared/components/otp-input/otp-input';

import { mapMutations, mapState } from 'vuex';
import { EdexAuth } from '@adobe/edex/ui/shared/config/auth';

export default {
  seo() {
    return {
      title: this.member?.fullName,
    };
  },
  components: {
    Loader,
    ConfirmModal,
    OtpConfirmModal,
  },
  data() {
    return {
      loading: false,
      confirmDeactivation: false,
      showAddButton: true,
      confirmOtpInput: false,
      formData: null,
      schoolemail: '',
      otpCode: '',
      disableSendButton: true,
      errorStatus: false,
      errorMesg: 'i18n.otp.code.error.mesg',
      otpLoader: false,
    };
  },
  created() {
    if (this.$route.query['verifyOtp'] !== undefined &&
      !Array.isArray(this.$route.query.verifyOtp) &&
      this.$route.query['verifyOtp'] === 'true') {
      this.confirmOtpInput = true;
    } else {
      this.confirmOtpInput = false;
    }
  },
  computed: {
    ...mapState('member', ['member']),
    notificationFormGroups() {
      return [
        {
          label: 'i18n.Notifications',
          id: 'notifications',
        },
        {
          label: 'i18n.Surveys',
          id: 'surveys',
        },
        {
          label: 'i18n.Newsletters',
          id: 'newsletters',
        },
        {
          label: 'i18n.K12Emails',
          id: 'k12Emails',
        },
        {
          label: 'i18n.Unsubscribe_From_All_Emails',
          id: 'unsubscribeFromAll',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('member', ['setMember']),
    async onUpdate(event) {
      if (event.target.name === 'unsubscribeFromAll') {
        if (event.target.value === 'true') {
          this.formData.newsletters = false;
          this.formData.surveys = false;
          this.formData.notifications = false;
          this.formData.k12Emails = false;
        } else {
          return;
        }
      }

      const { unsubscribeFromAll, ...settings } = this.formData;
      this.loading = true;
      const { data } = await memberAPI.updateSelfSettings({ settings });
      this.setMember(data);
      this.loading = false;
    },

    async updateSchoolEmail() {
      const { data } = await memberAPI.updateSchoolEmail(this.schoolemail);
      this.setMember(data);
      this.$refs.otpInput.clearInput();
      this.confirmOtpInput = true;
    },

    async removeSchoolEmail() {
      const { data } = await memberAPI.removeSchoolEmail();
      this.setMember(data);
      this.showAddButton = true;
    },

    onDeactivate() {
      this.confirmDeactivation = true;
    },

    onChangeOtpComplete({detail: {value}}) {
      this.otpCode = value;
    },

    async onVerifyOtpCode() {
      this.otpLoader = true;
      try {
        const { status, data } = await memberAPI.verifySchoolEmail(this.otpCode);
        if (status !== 200) {
          this.errorStatus = true;
        } else {
          this.setMember(data);
          this.otpCode = '';
          this.confirmOtpInput = false;
        }
      } catch (e) {
        console.log(e);
        this.errorStatus = true;
      }
      this.otpLoader = false;
    },

    async resendOtpCode() {
      await memberAPI.resendVerificationEmail();
      this.confirmOtpInput = true;
      this.errorStatus = false;
      this.$refs.otpInput.clearInput();
    },

    onDisableAddButton() {
      this.showAddButton = !this.showAddButton;
    },

    async onDeactivateConfirmed() {
      this.confirmDeactivation = false;
      await memberAPI.deactivateSelf();
      await EdexAuth.signOut();
    },
  },
  watch: {
    member: {
      handler(member) {
        if (!member) {
          return;
        }
        const { newsletters, surveys, notifications, k12Emails } = member.settings;
        this.formData = {
          ...member.settings,
          unsubscribeFromAll: !(newsletters || surveys || notifications || k12Emails),
        };
      },
      immediate: true,
    },
    schoolemail: {
      handler(schoolemail) {
        if (/(.+)@(.+){2,}\.(.+){2,}/.test(schoolemail)) {
          this.disableSendButton = false;
        } else {
          this.disableSendButton = true;
        }
      },
    },
  },
};
